export default __webpack_public_path__ + "src/docs/packages/kumbu-kumbu-lodge.pdf";